<script lang="ts">
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import translations from "../../../vertiflex/src/templates/Contact.translations.json";
	import type { Contact } from "../../../../core/schema/Contact.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { getSharedTranslate } from "../../utils/getSharedTranslate.js";

	export let contact: Contact;
	export let extended = false;

	const translate = getSharedTranslate(translations);
</script>

<div
	class="{extended
		? 'max-w-none lg:max-w-none'
		: 'max-w-[25rem] lg:max-w-[22rem]'} flex w-full gap-4 rounded-lg bg-gray-300 p-4 md:flex-col md:gap-3 lg:p-8"
>
	<div class="h-[4rem] w-[4rem] sm:h-[6rem] sm:w-[6rem] md:h-[8rem] md:w-[8rem]">
		<DynamicPicture
			bucket="storage"
			imgClass="rounded-full w-full h-full object-cover"
			class="relative aspect-square"
			loading="lazy"
			image={contact.image}
			width={200}
			height={200}
			alt={contact.name}
		/>
	</div>
	<div class="flex w-4/6 flex-col md:h-full md:w-full md:justify-between">
		<div class="flex flex-col md:h-full">
			<p class="lg:text-2lg text-primary font-spaceGrotesk text-md mb-0 font-medium leading-tight md:mt-2 md:text-lg">
				{nbspify(contact.name)}
			</p>
			<span
				class="{extended
					? 'mb-0'
					: 'mb-1 sm:mb-3 md:mb-4'} text-primary text-3xs sm:text-2xs block uppercase leading-tight tracking-wider md:text-base"
			>
				{nbspify(contact.position)}
			</span>

			{#if extended && contact.description}
				<p class="text-4xs my-1 leading-tight sm:my-3 md:my-4 md:text-xs md:leading-normal">
					{contact.description}
				</p>
			{/if}
		</div>
		<div class="grid grid-cols-6 md:grid-cols-5">
			{#if contact.email}
				<p class="text-3xs sm:text-2xs mb-0 hidden leading-[1.6] sm:inline-block md:text-xs">E-mail:</p>
				<span
					class="text-3xs sm:text-2xs col-span-5 mb-0 font-semibold leading-[1.6] underline underline-offset-2 md:col-span-4 md:text-xs"
					><a href="mailto:{contact.email}">{nbspify(contact.email)}</a></span
				>
			{/if}
			{#if contact.phone}
				<p class="text-3xs sm:text-2xs mb-0 hidden leading-[1.6] sm:inline-block md:text-xs">
					{translate("phone")}:
				</p>
				<span class="text-3xs sm:text-2xs col-span-5 mb-0 font-semibold leading-[1.6] md:col-span-4 md:text-xs"
					><a href="tel:{contact.phone}">{nbspify(contact.phone)}</a></span
				>
			{/if}
		</div>
	</div>
</div>
